import uuid from "uuid/v1";
import PriorityProcessingImage from "./PriorityProcessings.base6";
import {
  giftImg,
  fastShippingImg,
  warranteeImg,
  fastProcessingImg
} from "assets/products";
import Languages from "./translations";
// import compareVersions from 'compare-versions';

export const BREAK_POINTS = {
  kill_draft: (shopContext) => {
    return shopContext.state.settings.multiCurrencyMode;
    // const installedAt = new Date(shopContext.state.installedAt).getTime();
    // const breakPoint = new Date('Sun Apr 18 2021 15:00:00 GMT+0100').getTime();
    // return installedAt > breakPoint;
  }
};

export const CAMPAIGN_TARGETS = [
  {
    value: "all_products",
    label: "All Products",
    disabled: ({ state }, shopContext) => {
      return BREAK_POINTS["kill_draft"](shopContext)
        ? state.settings.type === "bundles"
        : false;
    }
  },
  { value: "specific_products", label: "Specific Products" },
  { value: "specific_collections", label: "Specific Collections" }
];
export const ADD_TO_UNLOCK_FREE_SHIPPING_HANDLER = [
  {
    value: false,
    label: "MonsterUpsells",
    info: "Shopify will inject a unique Free Shipping coupon code at checkout"
  },
  {
    value: true,
    label: "Shopify Admin",
    info: "You need to setup Free Shipping threshold in Shopify Admin",
    link: {
      href: "https://help.shopify.com/en/manual/shipping/setting-up-and-managing-your-shipping/setting-up-shipping-rates?fbclid=IwAR3OtBxohPJS0X1kzl1sOLfIqyCHkJkiLGiJPwmeAlkK3MAfZN6VdtmQw2s#create-free-shipping-rates",
      text: "Learn More"
    }
  }
];
export const CAMPAIGN_TYPES = {
  bundles: "buy more save more",
  add_to_unlock: "Add to unlock + Frequently bought Together",
  one_check_up_sell: "one tick upsell"
};

export const ONE_CHECK_UP_SELL_PRODUCT_TYPE_OPTIONS = [
  { value: "hidden", label: "Virtual Product" },
  { value: "existing", label: "Existing Product" }
];

export const GOOGLE_FONTS = [
  { value: "Raleway", label: "Raleway" },
  { value: "Dosis", label: "Dosis" }
];

export const RESOURCE_PICKER_DEFAULT_REDUCERS = {
  Product: ({ id, title, variants, images, handle }) => ({
    id,
    title,
    handle,
    image: images.length ? images[0].originalSrc : null,
    price: variants[0].price
  }),
  Collection: ({ id, title, image, handle }) => ({
    id,
    title,
    handle,
    image: image && image.originalSrc ? image.originalSrc : null
  })
};

export const ADD_TO_UNLOCK_PRODUCTS_PICKER_REDUCER = ({
  id,
  title,
  variants,
  options,
  images,
  handle
}) => ({
  id,
  title,
  handle,
  image: images.length ? images[0].originalSrc : null,
  variants: variants.map(ADD_TO_UNLOCK_PRODUCTS_VARIANTS_MAP),
  options
});

export const ONE_CHECK_UP_SELL_PRODUCT_REDUCER = ({
  id,
  title,
  variants,
  options,
  images,
  image,
  handle,
  body_html
}) => ({
  id: id.toString(),
  title: title.toString(),
  handle,
  image: image ? image.originalSrc : images[0].src || images[0].originalSrc,
  variant_id: variants[0].id.toString(),
  options,
  variants: variants.map(ADD_TO_UNLOCK_PRODUCTS_VARIANTS_MAP)
});

const ADD_TO_UNLOCK_PRODUCTS_VARIANTS_MAP = ({ id, title, price, image }) => ({
  id: id.toString(),
  title,
  price,
  image: image ? image.originalSrc : null
});

export const DISCOUNT_TYPES = (currency = "$ ") => [
  { label: "% ", value: "percentage" },
  { label: `${currency} `, value: "fixed_amount" }
];

export const GET_GOAL_TYPES = (currency = "$ ") => {
  return [
    { label: "% ", value: "relative" },
    { label: `${currency} `, value: "fixed" }
  ];
};

export const ADD_TO_UNLOCK_REWARD_OPTIONS = (goals, index) => {
  const otherGoals = goals
    .filter((_, i) => i !== index)
    .map(({ reward_type }) => reward_type);
  return [
    {
      value: "discount",
      label: "Discount",
      info: "Unlock discounts that will be auto aded to the checkout using discount codes"
    },
    {
      value: "free_shipping",
      label: "Free Shipping",
      info: "You need to setup free shipping options in Shopify Admin",
      disabled: otherGoals.includes("free_shipping")
    },
    {
      value: "manual",
      label: "Manual",
      infoHtml: true,
      info: "Create a goal that you will reward yourself.<br/><b>Example:</b> Free products, Gift wrapping, Free express shipping"
    }
  ];
};

export const CART_SLIDER_SETTINGS = {
  dots: false,
  arrows: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: false,
  draggable: false,
  infinite: false,
  easing: "easeOut"
};

const default_background = { r: 255, g: 255, b: 255, a: 1 };
const default_primary = { a: 1, b: 248, g: 117, r: 90 };
const default_secondary = { a: 1, b: 255, g: 222, r: 215 };
const default_font_color = { r: 22, g: 37, b: 67, a: 1 };
const default_danger = { r: 239, g: 68, b: 68, a: 1 };

export const NEW_CAMPAIGN_INITIAL_STATE = (
  {
    checkout_button = {
      background: default_primary,
      hoverBackground: default_secondary
    },
    primary = default_primary,
    secondary = default_secondary,
    font_color = default_font_color,
    background = default_background,
    danger = default_danger,
    type = "add_to_unlock",
    multiCurrencyMode
  } = {},
  language
) => {
  language = Object.keys(Languages).includes(language) ? language : "english";
  return {
    name: "",
    settings: {
      type,
      applied_discount_title: "Special Discount",
      bundles: {
        text: Languages[language].campaigns.bundles.text,
        prefix: Languages[language].campaigns.bundles.prefix,
        font_size: 0.8,
        background: secondary,
        color: font_color,
        activeBackground: primary,
        activeColor: background,
        list: [
          {
            id: uuid(),
            type: "percentage",
            quantity: 2,
            reward: 10
          },
          {
            id: uuid(),
            type: "percentage",
            quantity: 3,
            reward: 15
          }
        ]
      },
      add_to_unlock: {
        isActive: true,
        show_all_locked_goals: false,
        title: {
          text: Languages[language].campaigns.add_to_unlock.title.text,
          font_size: 1.1,
          color: font_color
        },
        background: secondary,
        borderColor: secondary,
        show_product_details: {
          text: Languages[language].campaigns.add_to_unlock.show_product_details
            .text,
          font_size: 0.7,
          color: primary
        },
        product_title: {
          text: "{{product_title}}",
          font_size: 1.1,
          color: font_color
        },
        product_price: {
          text: "only {{product_price}}",
          font_size: 0.9,
          color: font_color
        },
        upsell_add_button: {
          text: Languages[language].campaigns.add_to_unlock.upsell_add_button
            .text,
          color: primary,
          font_size: 0.8
        },
        upsell_confirm_button: {
          text: Languages[language].campaigns.add_to_unlock
            .upsell_confirm_button.text,
          font_size: 0.8
        },
        show_suggestions: true,
        recommendation_type: "shopify_recommendation", // or custom_recommendation shopify_recommendation
        products_length: 2,
        exclude_tags: [],
        products: [],
        separator: {
          active: false,
          text: Languages[language].campaigns.add_to_unlock.separator.text
        },
        multi_goal_type: "amount", //  quantity
        goals: [
          {
            goal: 40,
            reward_type: "discount", // free_shipping,discount, manual
            goal_type: "fixed",
            goal_text: {
              text: "10% Off",
              font_size: 0.7,
              color: {
                r: 44,
                g: 50,
                b: 59,
                a: 1
              }
            },
            show_goal_text: false,
            confetti: false,
            confetti_length: 400,
            discount: {
              type: "percentage",
              before:
                Languages[language].campaigns.add_to_unlock.discount.before,
              after: Languages[language].campaigns.add_to_unlock.discount.after,
              reward: 10
            },
            free_shipping: {
              before:
                Languages[language].campaigns.add_to_unlock.free_shipping
                  .before,
              after:
                Languages[language].campaigns.add_to_unlock.free_shipping.after,
              manual: true
            },
            manual: {
              before:
                Languages[language].campaigns.add_to_unlock.free_shipping
                  .before,
              after:
                Languages[language].campaigns.add_to_unlock.free_shipping.after
            }
          }
        ],

        // goal: 20,
        // reward_type: 'free_shipping',
        // goal_type: multiCurrencyMode ? 'fixed' : 'relative',
        // discount: {
        // 	type: 'percentage',
        // 	before: Languages[language].campaigns.add_to_unlock.discount.before,
        // 	after: Languages[language].campaigns.add_to_unlock.discount.after,
        // 	reward: 10,
        // },
        // free_shipping: {
        // 	before: Languages[language].campaigns.add_to_unlock.free_shipping.before,
        // 	after: Languages[language].campaigns.add_to_unlock.free_shipping.after,
        // 	manual: false,
        // },
        separator: {
          active: false,
          text: Languages[language].campaigns.add_to_unlock.separator.text
        },
        progress_primary: default_primary,
        progress_secondary: default_secondary,
        progress_complete: {
          a: 1,
          r: 87,
          g: 239,
          b: 197
        },
        product_details: {
          atcButton: {
            color: {
              a: 1,
              b: 255,
              g: 255,
              r: 255
            },
            font_size: 1,
            text: Languages[language].product_details.atcButton.text
          },
          atcButton_background: {
            a: 1,
            b: 248,
            g: 117,
            r: 90
          },
          atcButton_hoverBackground: {
            a: 1,
            b: 206,
            g: 206,
            r: 206
          },
          external: false,
          readMore: {
            color: {
              a: 1,
              b: 248,
              g: 117,
              r: 90
            },
            font_size: 1,
            text: Languages[language].product_details.readMore.text
          },
          truncate: true,
          truncate_length: 200
        }
      },
      one_check_up_sell: {
        text: Languages[language].campaigns.one_check_up_sell.text,
        is_ticked_by_default: false,
        include_in_atu: true,
        highlight: default_primary,
        product: {},
        product_type: "existing",
        truncate: true,
        truncate_length: 25
      },
      modules: {
        order: ["checkout_button", "random_text", "order_note"],
        random_text: {
          text: Languages[language].modules.random_text.text,
          active: false
        },
        order_note: {
          text: Languages[language].modules.order_note.text,
          active: false
        },
        checkout_button: {
          active_continue_shopping_button: true,
          active_continue_shopping_underlined: true,
          continue_shopping_button: {
            text: "Continue shopping",
            font_size: 1,
            color: primary
          },
          button_text: {
            text: Languages[language].modules.checkout_button.button_text.text,
            font_size: 1.7,
            color: background
          },
          button_text_loading: {
            text: Languages[language].modules.checkout_button
              .button_text_loading.text,
            color: background
          },
          background: checkout_button.background,
          hoverBackground: checkout_button.hoverBackground,
          coupon: {
            background: checkout_button.background,
            hoverBackground: checkout_button.hoverBackground,
            active_background: checkout_button.background,
            active_color: secondary
          },
          coupon_alert_text: {
            text: Languages[language].modules.checkout_button.coupon_alert_text
              .text,
            font_size: 1,
            color: danger
          },
          use_coupon_code: {
            text: Languages[language].modules.checkout_button.use_coupon_code
              .text,
            font_size: 0.9,
            color: { r: 160, g: 160, b: 160, a: 1 }
          },
          enter_coupon_code: {
            text: Languages[language].modules.checkout_button.enter_coupon_code
              .text,
            font_size: 0.9,
            color: secondary
          },
          apply_coupon_code: {
            text: Languages[language].modules.checkout_button.apply_coupon_code
              .text,
            font_size: 1,
            color: background
          },
          edit_coupon_code: {
            text: Languages[language].modules.checkout_button.edit_coupon_code
              .text,
            font_size: 0.9
          },
          close_coupon_code: {
            text: Languages[language].modules.checkout_button.close_coupon_code
              .text,
            font_size: 0.9
          },
          subtotal: {
            text: Languages[language].modules.checkout_button.subtotal.text,
            font_size: 1.3,
            color: font_color
          },
          savings: {
            text: Languages[language].modules.checkout_button.savings.text,
            font_size: 1.3,
            color: checkout_button.background
          }
        }
      }
    },
    target: {
      type: "all_products",
      selected: [],
      countries: {
        include_active: false,
        include: ["worldwide"],
        exclude_active: false,
        exclude: []
      }
    }
  };
};

export const SHOP_DEFAULT_SETTINGS = (language) => {
  language = Object.keys(Languages).includes(language) ? language : "english";
  return {
    modules: NEW_CAMPAIGN_INITIAL_STATE({}, language).settings.modules,
    active: false,
    open_cart: true,
    multiCurrencyMode: true,
    rtl: Languages[language].rtl,
    show_coupon: true,
    show_coupon_alert_text: true,
    is_checkout_condition_active: false,
    checkout_condition_color: default_primary,
    checkout_condition_text: "I agree to <b>Terms & conditions</b>",
    active_continue_shopping_button: false,	
    active_continue_shopping_underlined: true,	
    continue_shopping_button: {	
      text: "Continue shopping",	
      font_size: 1,	
      font_weight: 700,	
      color: default_primary	
    },
    empty_cart:
      '<p class="ql-align-center"><img src="data:image/png;base64,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"></p>',
    font: {
      color: {
        a: 1,
        b: 67,
        g: 37,
        r: 22
      },
      custom: true,
      family:
        "Poppins:100,100italic,200,200italic,300,300italic,regular,italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic",
      size: 14
    },
    header: {
      background: {
        a: 1,
        b: 233,
        g: 233,
        r: 233
      },
      title: {
        color: {
          a: 1,
          b: 0,
          g: 0,
          r: 0
        },
        font_size: 1.2,
        text: Languages[language].header.title
      }
    },
    product: {
      sold_out: Languages[language].product.sold_out,
      grow: true,
      image_size: 80,
      price: {
        color: {
          a: 1,
          b: 67,
          g: 37,
          r: 22
        },
        font_size: 1.1,
        text: "{{original_price}}{{product_price}}"
      },
      title: {
        color: {
          a: 1,
          b: 67,
          g: 37,
          r: 22
        },
        font_size: 1.1,
        text: "{{product_title}}"
      }
    },
    product_details: {
      atcButton: {
        color: {
          a: 1,
          b: 255,
          g: 255,
          r: 255
        },
        font_size: 1,
        text: Languages[language].product_details.atcButton.text
      },
      atcButton_background: {
        a: 1,
        b: 178,
        g: 84,
        r: 64
      },
      atcButton_hoverBackground: {
        a: 1,
        b: 206,
        g: 206,
        r: 206
      },
      external: false,
      readMore: {
        color: {
          a: 1,
          b: 178,
          g: 84,
          r: 64
        },
        font_size: 1,
        text: Languages[language].product_details.readMore.text
      },
      truncate: true,
      truncate_length: 200
    },
    theme: {
      background: {
        a: 1,
        b: 255,
        g: 255,
        r: 255
      },
      primary: {
        a: 1,
        b: 248,
        g: 117,
        r: 90
      },
      secondary: {
        a: 1,
        b: 255,
        g: 222,
        r: 215
      }
    },
    default_language: language,

    cod_settings: {
      error_message: "This field is required",
      is_active: false,
      is_form_in_cart: false,
      checkout_mode: "cod_and_checkout", // cod_and_checkout cod_only
      checkout_button: {
        text: "PAY ON DELIVERY",
        font_size: 1.7,
        color: default_background,
        background: default_primary,
        hoverBackground: default_secondary
      },
      confirm_button: {
        text: "Confirm Order",
        font_size: 1.7,
        color: default_background,
        background: default_primary,
        hoverBackground: default_secondary
      },
      loading_button: {
        text: "Loading ...",
        font_size: 1.7,
        color: default_background,
        background: default_primary,
        hoverBackground: default_secondary
      },
      form: [
        {
          label: "First name", // editable
          isRequired: true, // obligatry for customer
          type: "name",
          placeholder: "Please enter your full name"
        },
        {
          label: "Email",
          isRequired: false,
          type: "email",
          placeholder: "Please enter your email"
        },
        // {
        // 	label: "Zip Code",
        // 	isRequired: true
        // },
        {
          label: "Phone number",
          isRequired: true,
          type: "phone",
          placeholder: "Please enter your phone number"
        },
        {
          label: "Address",
          isRequired: true,
          type: "string",
          placeholder: "Please enter your address"
        },
        {
          label: "Note to seller",
          isRequired: false,
          type: "textarea",
          placeholder: "Please enter your a custome note"
        }
      ]
    },
    sticky_cart: {
      isActive: false,
      btn_style: "square",
      btn_text: "Add To Cart",
      btn_text_variant_active: "CONFIRM",
      btn_text_unavailable: "UNAVAILABLE",
      btn_color: default_primary,
      txt_color: {
        r: 255,
        g: 255,
        b: 255,
        a: 1
      },
      background_color: {
        r: 255,
        g: 255,
        b: 255,
        a: 1
      },

      atc_action: "checkout",

      desktop_active: true,
      desktop_show_variants: true,
      desktop_show_quantity: true,
      desktop_show_product_name: true,
      desktop_product_preview: true,
      desktop_show_compared_price: true,

      desktop_visibility: "dynamic",
      desktop_location: "bottom",

      desktop_quantity: { 
        text: "Quantity",
        // font_size: 1.7,
      },
      mobile_quantity: { 
        text: "Quantity",
        // font_size: 1.7,
      },
      cart_name: {
        text: "Add To Cart",
        // font_size: 1.7,
      },
      mobile_active: true,
      mobile_show_variants: true,
      mobile_show_quantity: true,
      mobile_show_compared_price: true,

      mobile_show_title: true,
      mobile_show_price: true,

      mobile_visibility: "dynamic",
      mobile_location: "bottom",
      mobile_atc_height: {
        text: 50
      },

      show_btn_atc_txt_variant_active: false,
      btn_atc_txt_variant_active: "Choose size"
    },
    scary: {
      isActive: false,
      text: {
        color: {
          a: 1,
          r: 0,
          g: 45,
          b: 255
        },
        font_size: 0.7,
        text: "🔥 Your cart is reserved for... {{timer}} minutes"
      },
      style: "rounded",
      background: {
        a: 1,
        r: 240,
        g: 242,
        b: 255
      },
      border: {
        a: 1,
        r: 161,
        g: 178,
        b: 255
      },
      isDaysActive: false,
      isHoursActive: true,
      isMinutesActive: true,
      isSecondsActive: true,
      days: 0,
      hours: 0,
      minutes: 4,
      seconds: 49,
      endAction: "hide", // hide restart
      placement: "bottom", // bottom top
      textAlignement: "left" // left center right
    }
  };
};
export const BADGE_PERCENT_ICON = {
  //this icon is missing on fontawesome package
  prefix: "fas",
  iconName: "adjust",
  icon: [
    512,
    512,
    [],
    "f646",
    "M512 256c0-37.7-23.7-69.9-57.1-82.4 14.7-32.4 8.8-71.9-17.9-98.6-26.7-26.7-66.2-32.6-98.6-17.9C325.9 23.7 293.7 0 256 0s-69.9 23.7-82.4 57.1c-32.4-14.7-72-8.8-98.6 17.9-26.7 26.7-32.6 66.2-17.9 98.6C23.7 186.1 0 218.3 0 256s23.7 69.9 57.1 82.4c-14.7 32.4-8.8 72 17.9 98.6 26.6 26.6 66.1 32.7 98.6 17.9 12.5 33.3 44.7 57.1 82.4 57.1s69.9-23.7 82.4-57.1c32.6 14.8 72 8.7 98.6-17.9 26.7-26.7 32.6-66.2 17.9-98.6 33.4-12.5 57.1-44.7 57.1-82.4zm-320-96c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32zm12.28 181.65c-6.25 6.25-16.38 6.25-22.63 0l-11.31-11.31c-6.25-6.25-6.25-16.38 0-22.63l137.37-137.37c6.25-6.25 16.38-6.25 22.63 0l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63L204.28 341.65zM320 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
  ]
};

const parseProductId = (string) => {
  // example gid://shopify/ProductVariant/19566771404862
  const pattern = new RegExp("gid://shopify/Product/([0-9]+)$");
  if (pattern.test(string)) return parseInt(string.match(pattern)[1]);
  return string;
};

export const stateCards = [
  { title: "CartsDisplayed" },
  { title: "SalesGenerated" },
  { title: "SalesAmount", currency: true },
  { title: "AverageOrderSize", currency: true },
  { title: "CartConversionRate", suf: "%" },
  { title: "UpsellsGenerated" },
  { title: "UpsellsTotalAmount", currency: true },
  { title: "TotalROI", suf: "%", clickable: false }
];

export const chartOptions = (formatter) => ({
  fill: {
    type: "solid",
    color: "#485aff",
    opacity: 0.15
  },
  width: "50%",
  stroke: {
    show: true,
    curve: "smooth",
    lineCap: "butt",
    colors: ["#2F80ED"],
    width: 4,
    dashArray: 0
  },
  dropShadow: {
    enabled: true,
    top: 1,
    left: 1,
    blur: 2,
    color: "#000",
    opacity: 0.9
  },
  xaxis: {
    type: "datetime"
  },
  yaxis: {
    type: "numeric"
  },
  dataLabels: {
    enabled: false,
    enabledOnSeries: undefined,
    formatter
  }
});

export const ENGINE_WARNING_ICON = {
  prefix: "fas",
  iconName: "engine-warning",
  icon: [
    640,
    448,
    [],
    "f5f2",
    "M48 256c0-59.53 19.55-117.38 55.36-164.51 5.18-6.81 4.48-16.31-2.03-21.86l-12.2-10.41c-6.91-5.9-17.62-5.06-23.15 2.15C23.32 117.02 0 185.5 0 256c0 70.47 23.32 138.96 65.96 194.62 5.53 7.21 16.23 8.05 23.15 2.16l12.19-10.4c6.51-5.55 7.21-15.04 2.04-21.86C67.55 373.37 48 315.53 48 256zM320 32C196.3 32 96 132.3 96 256c0 123.76 100.3 224 224 224s224-100.24 224-224c0-123.7-100.3-224-224-224zm0 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.44-110.41c-.82 8.18-7.7 14.41-15.92 14.41h-19.04c-8.22 0-15.1-6.23-15.92-14.41l-12.8-128c-.94-9.42 6.45-17.59 15.92-17.59h44.64c9.47 0 16.86 8.17 15.92 17.59l-12.8 128zM572.73 59.71c-5.58-7.18-16.29-7.95-23.17-2l-12.15 10.51c-6.47 5.6-7.1 15.09-1.88 21.87C572.04 137.47 592 195.81 592 256c0 60.23-19.96 118.57-56.46 165.95-5.22 6.78-4.59 16.27 1.88 21.87l12.15 10.5c6.87 5.95 17.59 5.18 23.17-2C616.21 396.38 640 327.31 640 256c0-71.27-23.79-140.34-67.27-196.29z"
  ]
};
export const SACK_DOLLAR_ICON = {
  prefix: "fas",
  iconName: "sack-dollar",
  icon: [
    512,
    512,
    [],
    "f81d",
    "M192 96h128l47.4-71.12A16 16 0 0 0 354.09 0H157.94a16 16 0 0 0-13.31 24.88zm128 32H192C-10.38 243.4.09 396.64.09 416c0 53 49.11 96 109.68 96h292.48c60.58 0 109.68-43 109.68-96 0-19 9.35-173.24-191.93-288zm-46.58 278v17.34a8.68 8.68 0 0 1-8.7 8.62h-17.41a8.69 8.69 0 0 1-8.71-8.62v-17.51a63.14 63.14 0 0 1-34.16-12.17 8.52 8.52 0 0 1-.67-13l12.84-12.06a8.93 8.93 0 0 1 11-.76 26.71 26.71 0 0 0 13.93 4h30.58c7.07 0 12.84-6.35 12.84-14.22 0-6.46-3.92-12.06-9.58-13.67l-49-14.54c-20.24-6-34.39-25.2-34.39-46.74 0-26.38 20.68-47.82 46.46-48.57v-17.48a8.69 8.69 0 0 1 8.75-8.62h17.41a8.68 8.68 0 0 1 8.7 8.62v17.55a63.15 63.15 0 0 1 34.17 12.17 8.54 8.54 0 0 1 1.58 12 8.72 8.72 0 0 1-.92 1l-12.73 12.2a8.91 8.91 0 0 1-11 .75 26.8 26.8 0 0 0-13.93-4h-30.57c-7.07 0-12.84 6.35-12.84 14.21 0 6.46 3.92 12.06 9.57 13.68l49 14.54c20.24 6 34.38 25.2 34.38 46.74-.14 26.4-20.92 47.94-46.6 48.54z"
  ]
};

export const COMMENT_DOLLAR = {
  prefix: "fas",
  iconName: "comment-dollar",
  icon: [
    512,
    512,
    [],
    "f81d",
    "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
  ]
};
export const BOX_CHECK_ICON = {
  prefix: "fas",
  iconName: "box-check",
  icon: [
    640,
    512,
    [],
    "f467",
    "M240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zm235.2 81.7l-16.3-48.8C452.4 13.2 434.1 0 413.4 0H272v157.4C315.9 109.9 378.4 80 448 80c9.2 0 18.3.6 27.2 1.7zM208 320c0-34.1 7.3-66.6 20.2-96H0v240c0 26.5 21.5 48 48 48h256.6C246.1 468.2 208 398.6 208 320zm240-192c-106 0-192 86-192 192s86 192 192 192 192-86 192-192-86-192-192-192zm114.1 147.8l-131 130c-4.3 4.3-11.3 4.3-15.6-.1l-75.7-76.3c-4.3-4.3-4.2-11.3.1-15.6l26-25.8c4.3-4.3 11.3-4.2 15.6.1l42.1 42.5 97.2-96.4c4.3-4.3 11.3-4.2 15.6.1l25.8 26c4.2 4.3 4.2 11.3-.1 15.5z"
  ]
};
export const PERCENTAGE_ICON = {
  prefix: "fas",
  iconName: "percentage",
  icon: [
    384,
    512,
    [],
    "f541",
    "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
  ]
};

export const COMMENT_ALT_SMILE_ICON = {
  prefix: "fas",
  iconName: "comment-alt-smile",
  icon: [
    512,
    512,
    [],
    "f4aa",
    "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM320 133.2c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8 12-26.8 26.8-26.8zm-128 0c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8 12-26.8 26.8-26.8zm164.2 140.9C331.3 303.3 294.8 320 256 320c-38.8 0-75.3-16.7-100.2-45.9-5.8-6.7-5-16.8 1.8-22.5 6.7-5.7 16.8-5 22.5 1.8 18.8 22 46.5 34.6 75.8 34.6 29.4 0 57-12.6 75.8-34.7 5.8-6.7 15.9-7.5 22.6-1.8 6.8 5.8 7.6 15.9 1.9 22.6z"
  ]
};

export const USER_SHIELD_ICON = {
  prefix: "fas",
  iconName: "user-shield",
  icon: [
    640,
    512,
    [],
    "f505",
    "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
  ]
};

export const PRESET_HIDDEN_PRODUCTS = [
  {
    id: 1,
    title: "Gift Wrappping",
    price: 2.55,
    body_html:
      "<p>Buying&nbsp;a&nbsp;Gift?&nbsp;Let&nbsp;us&nbsp;wrap&nbsp;it&nbsp;for&nbsp;you!</p><p>One of our team, will carefully wrap all you items individually to make your (someone special)...feel special!</p>",
    image: giftImg
  },
  {
    id: 4,
    title: "Fast Processing",
    price: 2.55,
    body_html:
      "<p>Want to get your order FAST?</p><p>Get Priority Processing and we'll bump your order up to the front of the line.&nbsp;</p>",
    image: fastProcessingImg
  },
  {
    id: 2,
    title: "Extended waranty",
    price: 4.19,
    body_html: "<p>We will cover any manufacturing faults for 2 years!</p>",
    image: warranteeImg
  }
];
export const TEST_COOKIE_NAME = "shopifyTestCookie";
export const GRANTED_STORAGE_ACCESS_COOKIE_NAME =
  "shopify.granted_storage_access";

export const DEFAULT_GOAL = ({ multi_goal_type, goals }, language) => {
  language = Object.keys(Languages).includes(language) ? language : "english";
  const index = goals.length;
  const goal = multi_goal_type === "amount" ? 40 + 20 * index : 2 + 2 * index;
  const reward = 10 + 5 * index;
  return {
    goal,
    reward_type: "discount", // free_shipping,discount
    goal_type: "fixed",
    goal_text: {
      text: reward + "% OFF",
      font_size: 0.7,
      color: {
        r: 44,
        g: 50,
        b: 59,
        a: 1
      }
    },
    show_goal_text: true,
    confetti: false,
    confetti_length: 400,
    discount: {
      type: "percentage",
      before: Languages[language].campaigns.add_to_unlock.discount.before,
      after: Languages[language].campaigns.add_to_unlock.discount.after,
      reward
    },
    free_shipping: {
      before: Languages[language].campaigns.add_to_unlock.free_shipping.before,
      after: Languages[language].campaigns.add_to_unlock.free_shipping.after,
      manual: true
    },
    manual: {
      before: Languages[language].campaigns.add_to_unlock.free_shipping.before,
      after: Languages[language].campaigns.add_to_unlock.free_shipping.after
    }
  };
};
export const COD_FORM = [];

export const STICKY_CART_OPTIONS = {
  btnStyles: [
    { value: "square", label: "Square" },
    { value: "curvy", label: "Curvy" }
    // { value: 'organic', label: 'Organic' },
  ],
  btnPosition: [
    { value: "bottom", label: "Bottom" },
    { value: "top", label: "Top" }
  ],
  visibilityOptions: [
    { value: "always", label: "Always" },
    { value: "dynamic", label: 'when "Add To Cart" is hidden' }
  ],
  atcActions: [
    { value: "checkout", label: "Redirect to checkout page" },
    { value: "cart", label: "Redirect to cart" },
    { value: "stay", label: "Stay in product page" }
  ]
};
